import React from "react";

export interface SidePanelDepartureArrivalProps {
  dateWritten?: string
  timeWritten: string
  sideInfo?: string
  addressLine1: React.ReactNode
  addressLine2: string
}

export const SidePanelDepartureArrival = (props: SidePanelDepartureArrivalProps) => {
  const { dateWritten, timeWritten, sideInfo, addressLine1, addressLine2 } = props;

  return <div className="flex-column gap-small">

    <div className="flex justify-space-between">
      <div>
        <div><strong>{timeWritten}</strong></div>
        {dateWritten && <div>
          {dateWritten}
        </div>}
      </div>

      {sideInfo && <div><strong>{sideInfo}</strong></div>}
    </div>

    <div>
      <div>{addressLine1}</div>
      <div className="text-sublabel">{addressLine2}</div>
    </div>

  </div>
}